<template>
  <div id="divdd" class="customTable" style="height: 100%;width: 100%;position: absolute;" :style="{backgroundImage:tableStyle.backgroundImage,
            backgroundColor:tableStyle.backgroundColor}">
    <el-form ref="queryConfigForm" :model="queryModel" v-if="queryConfig.length>0" size="mini" :inline="true" style="text-align: center;"
      :style="{marginBottom:getQueryMarginBottomHeight()}">
      <el-row :gutter="0">
        <el-form-item v-for="(item,index) in queryConfig" :key="item.prop" :prop="item.prop">
          <label style="margin-right: 10px;" :style="{fontSize:getQueryFontSize(),
            fontWeight:queryStyle.fontWeight,
            color:queryStyle.color,

            backgroundImage:queryStyle.backgroundImage,
            backgroundColor:queryStyle.backgroundColor}">{{ item.label }}</label>
          <!--输入框表单类型-->
          <input type="text" :ref="item.prop" v-if="item.type ==='text'" v-model="queryModel[item.prop]"
            :style="{width:getQueryControlWidth(),
            height:getQueryControlHeight(),
            border:queryStyle.border,
            color:queryStyle.color,
           fontSize:getQueryControlFontSize(),
           fontWeight:queryStyle.fontWeight,
           backgroundImage:queryStyle.backgroundImage,
           backgroundColor:queryStyle.backgroundColor
           }" />
        </el-form-item>
        <el-form-item>
          <el-button  style="width:100%;height:100%;"v-if="queryConfig && queryConfig.length>0" class="filter-item" size="mini" type="success" :style="{fontSize:getQueryBtnFontSize(),
            fontWeight:queryBtnStyle.fontWeight,
            color:queryBtnStyle.color,
            border:queryBtnStyle.border,
            width:getQueryBtnWidth(),
            height:getQueryBtnHeight(),
            backgroundImage:queryBtnStyle.backgroundImage,
            backgroundColor:queryBtnStyle.backgroundColor}"
            icon="el-icon-search" @click="queryData">查询</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <div style="width: 100%;height: 100%;overflow-y: auto;">
      <table style="height: 100%;width: 100%; border-collapse:collapse;">
        <thead v-if="showHeader">
          <tr align="center">
            <template v-for="(item,index) in gridConfig">
              <th :key="index" v-if="checkShowColumn(item)" :style="{
            borderLeft:headerCellStyle.borderLeft,
            borderRight:headerCellStyle.borderRight,
            borderBottom:headerCellStyle.borderBottom,
            borderTop:headerCellStyle.borderTop,
            fontSize:getHeaderFontSize(),
            height:getHeaderHeight(),
            width:item.width+'%',
            fontWeight:headerCellStyle.fontWeight,
            color:headerCellStyle.color,
            backgroundImage:headerCellStyle.backgroundImage,
            backgroundColor:headerCellStyle.backgroundColor}">{{item.label}}
              </th>
            </template>
            <th v-if="showOperator" :style="{
            borderLeft:headerCellStyle.borderLeft,
            borderRight:headerCellStyle.borderRight,
            borderBottom:headerCellStyle.borderBottom,
            borderTop:headerCellStyle.borderTop,
            fontSize:getHeaderFontSize(),
            height:getHeaderHeight(),
            fontWeight:headerCellStyle.fontWeight,
            color:headerCellStyle.color,
            backgroundImage:headerCellStyle.backgroundImage,
            backgroundColor:headerCellStyle.backgroundColor}">
              操作
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="dragClass" v-for="(item,index) in gridData" :key="index" align="center">
            <template v-for="(item2,index) in gridConfig">
              <td v-if="checkShowColumn(item2)" :key="index" :style="{borderTop:rowCellStyle.borderTop,
            borderBottom:rowCellStyle.borderBottom,
            borderLeft:rowCellStyle.borderLeft,
            borderRight:rowCellStyle.borderRight,
            fontSize:getCellFontSize(),
            fontWeight:rowCellStyle.fontWeight,
            height:getCellHeight(),
            width:item2.width+'%',
            color:rowCellStyle.color,
            backgroundColor:rowCellStyle.backgroundColor}">
            <span style="padding-left: 10%;padding-right: 10%;" :style="{backgroundColor:getFieldColor(item2.prop,item[item2.prop])}">{{item[item2.prop]}}</span></td>
            </template>
            <td v-if="showOperator" :style="{borderTop:rowCellStyle.borderTop,
            borderBottom:rowCellStyle.borderBottom,
            borderLeft:rowCellStyle.borderLeft,
            borderRight:rowCellStyle.borderRight,
            fontSize:getCellFontSize(),
            fontWeight:rowCellStyle.fontWeight,
            height:getCellHeight(),
            color:rowCellStyle.color,
            backgroundColor:rowCellStyle.backgroundColor}">
              <el-button size="mini" type="text" @click="view(scope.row)" :style="{ fontSize:gridBtnStyle.fontSize,
            fontWeight:gridBtnStyle.fontWeight,
            fontSize:getGridFontSize(),
            color:gridBtnStyle.color}" >查看
              </el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <el-dialog custom-class="customEventClass" :append-to-body="true" :visible.sync="dialogVisible">

      </el-dialog>
    </div>
  </div>
</template>

<script>
  // import $ from 'jquery'
  // import drag from './tabledrag.js'
  import {
    getDataService
  } from '../../api/chart/chart/index.js'
  export default {
    props: {
      queryUrlConfig:{
        type:Object,
        default(){
          return {
            url:null,
            params:[]
          }
        }
      },
      fieldColorConfig:{
        type:Array,
        default(){
          //结构为prop,data:[{value,color}]
          return []
        }
      },
      chartConfig: {
        type: Object,
        default () {
          return {

          }
        }
      },
      //表格数据
      // 'gridData': {
      //   type: Array,
      //   default () {
      //     return []
      //   }
      // },
      'gridBtnConfig': {
        type: Object,
        default () {
          return {}
        }
      },
      // 查询条件
      'queryModel': {
        type: Object,
        default () {
          return {}
        }
      },
      'formData': {
        type: Object,
        default () {
          return {}
        }
      },
      // 表格配置
      'gridConfig': {
        type: Array,
        default () {
          return []
        }
      },
      'queryConfig': {
        type: Array,
        default () {
          return []
        }
      },
      'rowCellStyle': {
        type: Object,
        default () {
          return {}
        }
      },
      'headerCellStyle': {
        type: Object,
        default () {
          return {}
        }
      },
      'tableStyle': {
        type: Object,
        default () {
          return {}
        }
      },
      'gridBtnStyle': {
        type: Object,
        default () {
          return {}
        }
      },
      'queryBtnStyle': {
        type: Object,
        default () {
          return {}
        }
      },
      'queryStyle': {
        type: Object,
        default () {
          return {}
        }
      },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          }
        }
      }
    },
    data() {
      return {
        timer:null,
        chartConfigModel: this.chartConfig,
        dialogVisable:false,
        gridData:[],
        timer:null
      }
    },
    mounted() {

    },
    watch: {
      chartConfig: {
        handler(newValue, oldValue) {
          this.chartConfigModel = newValue
        },
        deep: true
      },
      queryUrlConfig:{
        handler(newValue, oldValue) {
          this.getData()
        },
        deep: true
      }

      // gridData: {
      //   handler(newValue, oldValue) {
      //     if(newValue){
      //       //drag.init("dragClass")
      //     }
      //   },
      //   deep: true
      // },
    },
    computed: {
      //是否显示头部
      showHeader() {
        if (this.chartConfig.isShowHeader == undefined ||
          this.chartConfig.isShowHeader == null ||
          this.chartConfig.isShowHeader == true) {
          return true
        }
        return false
      },
      //是否显示操作列
      showOperator() {
        if (this.chartConfig.isShowOperator == undefined ||
          this.chartConfig.isShowOperator == null ||
          this.chartConfig.isShowOperator == true) {
          return true;
        }
        return false
      }
    },
    mounted() {
      let that=this
      this.chartConfigModel = this.chartConfig
      this.getData()
      this.timer=setInterval(function(){
          that.getData()
      },1000*60*5)
    },
    beforeDestroy() {
       if(this.timer){
           clearInterval(this.timer)
           this.timer=null
       }
    },
    methods: {
      view(item){
        this.$emit("view",item)
      },
      getFieldColor(field,value){
        if(this.fieldColorConfig){
          for(let i=0;i<this.fieldColorConfig.length;i++){
            if(field==this.fieldColorConfig[i].prop){
              let _data=this.fieldColorConfig[i].data
              if(_data){
                for(let j=0;j<_data.length;j++){
                  if(_data[j].value==value){
                    return _data[j].color
                  }
                }
              }
            }
          }
        }
        return ""
      },
      getData(){
        let that=this
        that.gridData=[]
        if(this.queryUrlConfig && this.queryUrlConfig.url){
          let url=this.queryUrlConfig.url
          let params={}
          if(this.queryUrlConfig.params){
            for(let i=0;i<this.queryUrlConfig.params.length;i++){
              if(this.queryUrlConfig.params[i].target
               && this.queryUrlConfig.params[i].source){
                 let _value=fwUtil.Helper.GetQueryString(this.queryUrlConfig.params[i].source)
                 if(_value){
                   params[this.queryUrlConfig.params[i].target]=_value
                 }
               }
            }
          }
          getDataService(url,params).then((res)=>{
            that.gridData=res
          })

        }else{
          // that.gridData=that.defaultList
        }
      },
      query(){
        if(this.gridBtnStyle.click=='dialog'){
          this.dialogVisable=true
        }else{
          window.location.href=this.gridBtnStyle.href
        }
      },
      checkShowColumn(item) {
        if (item.isShow == undefined ||
          item.isShow == null ||
          item.isShow == true
        ) {
          return true
        }
        return false
      },
      queryData() {

        this.$emit('queryData', this.queryModel)
      },
      getGridFontSize() {
        let _fontSize = this.gridBtnStyle.fontSize ? this.gridBtnStyle.fontSize : 14
        let fontSize = _fontSize / this.page.width * this.screen.width
        return fontSize + 'px'
      },
      getQueryControlFontSize() {
        let _fontSize = this.queryStyle.fontSize ? this.queryStyle.fontSize : 14
        let fontSize = _fontSize / this.page.width * this.screen.width
        return (fontSize - 2) + 'px'
      },
      getQueryFontSize() {
        let _fontSize = this.queryStyle.fontSize ? this.queryStyle.fontSize : 14
        let fontSize = _fontSize / this.page.width * this.screen.width
        return fontSize + 'px'
      },
      getQueryControlWidth() {
        let _height = this.queryStyle.width ? this.queryStyle.width : 150;
        let height = _height / this.page.width * this.screen.width
        return height + 'px'
      },
      getQueryMarginBottomHeight() {
        let _height = this.queryStyle.marginBottom ? this.queryStyle.marginBottom : 40;
        let height = _height / this.page.height * this.screen.height
        return height + 'px'
      },
      getQueryControlHeight() {
        let _height = this.queryStyle.height ? this.queryStyle.height : 40;
        let height = _height / this.page.height * this.screen.height
        return height + 'px'
      },
      getQueryBtnFontSize() {
        let _height = this.queryBtnStyle.fontSize ? this.queryBtnStyle.fontSize : 14;
        let height = _height / this.page.weight * this.screen.weight
        return height + 'px'
      },
      getQueryBtnHeight() {
        let _height = this.queryBtnStyle.height ? this.queryBtnStyle.height : 40;
        let height = _height / this.page.height * this.screen.height
        return height + 'px'
      },
      getQueryBtnWidth() {
        let _height = this.queryBtnStyle.width ? this.queryBtnStyle.width : 80;
        let height = _height / this.page.width * this.screen.width
        return height + 'px'
      },
      getGridBtnFontSize() {
        let _height = this.gridBtnStyle.fontSize ? this.gridBtnStyle.fontSize : 14;
        let height = _height / this.page.width * this.screen.width
        return height + 'px'
      },
      getCellHeight() {
        let _height = this.rowCellStyle.height ? this.rowCellStyle.height : 40;
        let height = _height / this.page.height * this.screen.height
        return height + 'px'
      },
      getCellFontSize() {
        let _fontSize = this.rowCellStyle.fontSize ? this.rowCellStyle.fontSize : 14
        let fontSize = _fontSize / this.page.width * this.screen.width
        return fontSize + 'px'
      },
      getHeaderFontSize() {
        console.error("===header font size===")
        let _fontSize = this.headerCellStyle.fontSize ? this.headerCellStyle.fontSize : 14
        let fontSize = _fontSize / this.page.width * this.screen.width
        console.error("===header font size===" + fontSize)
        return fontSize + 'px'
      },
      getHeaderHeight() {
        let _height = this.headerCellStyle.height ? this.headerCellStyle.height : 40;
        let height = _height / this.page.height * this.screen.height
        return height + 'px'
      },
    }

  }
</script>

<style scoped="scoped">
  .customTable::-webkit-scrollbar {
    width: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/CustomUrlTable.vue